import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./locales/resources";
import { features } from "./utils/features";

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}
const savedLanguage = localStorage.getItem("i18nextLng");
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: process.env.NODE_ENV !== "production",
    fallbackLng: "pl",
    // Without the switch a language picked earlier could not be changed back, so it is ignored.
    lng: features.languageSwitch ? savedLanguage || "pl" : "pl",
    resources,
    detection: {
    
      order: ["localStorage", "cookie", "navigator"], 
      lookupLocalStorage: "i18nextLng", 
      caches: ["localStorage", "cookie"], 
    },
  });

export default i18n;
